import { authHttp } from 'utils/http';

const OpType = {
    GreaterEqual: '>=',
    InRange: '<=>',
    LessEqual: '<=',
};

export const getKeywordsPage = ({ asin, page }) => {
    return authHttp({
        method: 'get',
        url: `/keywords/reverse?asin=${asin}&limit=100&page=${page}`
    }).then((res) => res);
};

const serializeFilters = (filters = {}, categories = []) => {
    const index = Object.keys(filters).length;
    const keyword = categories.filter((el) => el.type === 'keyword')[0];
    const params = [];

    if (keyword) {
        params.push(`keyword=${keyword.name}`);
    }

    if (index) {
        Object.entries(filters).forEach(([filterName, filter], i) => {
            let op = '';
            if (filter.min && filter.max) op = OpType.InRange;
            else if (filter.min) op = OpType.GreaterEqual;
            else if (filter.max) op = OpType.LessEqual;
            else return;

            params.push(`filters[${i}][field]=${filterName}`);
            params.push(`filters[${i}][op]=${op}`);

            let value = filter.max; // OpType.LessEqual
            if (op === OpType.GreaterEqual) {
                value = filter.min;
            } else if (op === OpType.InRange) {
                value = [filter.min, filter.max];
            }

            if (op === OpType.InRange) {
                params.push(`filters[${i}][value]=[${value.join(',')}]`);
            } else {
                params.push(`filters[${i}][value]=${value}`);
            }
        });
    }
    categories.filter((x) => x.type !== 'keyword').forEach((cat, i) => {
        params.push(`filters[${index + i}][field]=categories`);
        params.push(`filters[${index + i}][op]=~`);
        params.push(`filters[${index + i}][value]=${cat.id || cat.nodeId}`);
    });

    return encodeURI(params.join('&'));
};

export const getKeywordsData = ({ page, filters, categories, sort, isStrict }) => {
    const sortParams = sort.field ? `&sort=${sort.field}&direction=${sort.type}` : '';
    let filtersData = serializeFilters(filters, categories);
    filtersData = filtersData ? `&${filtersData}` : '';
    const strict = isStrict ? 1 : 0;

    return authHttp({
        method: 'get',
        url: `/keywords/research?limit=50&page=${page}${sortParams}${filtersData}&strict=${strict}`
    }).then((res) => res);
};


export const trackKeyword = (data) => {
    return authHttp({
        data,
        method: 'post',
        url: '/keywords'
    }).then((res) => res.data);
};

export const getProduct = (asin) => {
    return authHttp({
        method: 'get',
        url: `/listings/preview?asin=${asin}`
    }).then((res) => res.data);
};

export const deepSearch = (keyword) => {
    return authHttp({
        data: {
            keyword
        },
        method: 'post',
        url: '/deep-searches'
    }).then((res) => res.data);
};

export const getHistory = (page = 1) => {
    return authHttp({
        method: 'get',
        url: `/deep-searches?limit=100&sort[createdAt]=desc&page=${page}`
    }).then((res) => res.data);
};

export const seeReport = (id) => {
    return authHttp({
        method: 'get',
        url: `/deep-searches/${id}`
    }).then((res) => res.data);
};

export const getCategories = (str, page = 0) => {
    const query = str ? `&query=${str}` : '';
    return authHttp({
        method: 'get',
        url: `/categories?embeds=children${query}&source=amazon&limit=100&filter[isPrimary]=1&page=${page}`,
    }).then((res) => res.data);
};

export const getSubCategories = (parentId, page = 0) => {
    return authHttp({
        method: 'get',
        url: `/categories?embeds=children&source=amazon&limit=100&filter[parentId]=${parentId}&page=${page}`
    }).then((res) => res.data);
};
